<template>
  <div class="app">
    <AppHeader fixed>
      <div class="d-flex">
        <b-link class="navbar-brand" to="#">
          <h4 class="ml-5 mt-2 logo">{{app_name}}</h4>
        </b-link>

        <b-navbar-nav class="d-md-down-none">
          <b-nav-item class="px-3" to="/dashboard" exact>داشبورد</b-nav-item>
          <b-nav-item
            v-if="base"
            class="px-3"
            :to="baseUrl"
            @click="_setNavItems('base')"
          >اطلاعات پایه
          </b-nav-item>

          <b-nav-item
            v-if="inventory"
            class="px-3"
            :to="inventoryUrl"
            @click="_setNavItems('inventory')"
          >انبار
          </b-nav-item>
          <b-nav-item
            v-if="order"
            class="px-3"
            :to="orderUrl"
            @click="_setNavItems('order')"
          >سفارشات
          </b-nav-item>
          <b-nav-item
            v-if="planning"
            class="px-3"
            :to="planningUrl"
            @click="_setNavItems('planning')"
            exact
          >مدیریت برنامه ریزی
          </b-nav-item>
          <b-nav-item
            v-if="works"
            class="px-3"
            :to="worksUrl"
            @click="_setNavItems('works')"
            exact
          >مدیریت تولید
          </b-nav-item>
          <b-nav-item
            v-if="pm"
            class="px-3"
            :to="pmUrl"
            @click="_setNavItems('pm')"
            exact
          >نگهداری تعمیرات
          </b-nav-item>
          <!--<b-nav-item class="px-3" to="/production-management" exact>مدیریت تولید</b-nav-item>-->
          <!--<b-nav-item-->
          <!--v-if="accountant"-->
          <!--class="px-3"-->
          <!--:to="accountantUrl"-->
          <!--@click="_setNavItems('accountant')"-->
          <!--exact-->
          <!--&gt;حسابداری-->
          <!--</b-nav-item>-->
          <!--<b-nav-item-->
          <!--v-if="biAccess"-->
          <!--class="px-3"-->
          <!--:to="biAccessUrl"-->
          <!--@click="_setNavItems('biAccess')"-->
          <!--exact-->
          <!--&gt;حقوق و دستمزد-->
          <!--</b-nav-item>-->
          <b-nav-item
            v-if="useradmin && (companyId ==1 || username ==='superadmin')"
            class="px-3"
            :to="useradminUrl"
            @click="_setNavItems('useradmin')"
          >مدیریت کاربرها
          </b-nav-item>
        </b-navbar-nav>
      </div>
      <div>
        <b-navbar-nav class="mr-auto">
          <div class="user-info">
            <span>{{company}} / {{post}} / {{username}}</span>
          </div>
          <DefaultHeaderDropdownAccnt/>
        </b-navbar-nav>
      </div>
    </AppHeader>
    <div class="app-body">
      <main class="main m-0">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view :key="$route.fullPath"></router-view>
        </div>
      </main>
    </div>
    <TheFooter class="m-0">
      <!--footer-->
      <div>
        <a href="https://badian-co.ir">چرخونه/ بدیعان اندیشه</a>
      </div>
      <div class="mr-auto">
        <span class="mr-1">Badian Andisheh</span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
  import nav from "@/_nav";
  import {
    Header as AppHeader,
    SidebarToggler,
    Sidebar as AppSidebar,
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNav,
    Aside as AppAside,
    AsideToggler,
    Footer as TheFooter,
    Breadcrumb
  } from "@coreui/vue";
  import DefaultAside from "./DefaultAside";
  import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
  import SideNav from "./Sidebar";
  import EventBus from "../bus.js";
  import Sidebar from "./Sidebar.vue";
  import Constants from "../Constants";

  export default {
    name: "full",
    components: {
      SideNav,
      // AsideToggler,
      AppHeader,
      AppSidebar,
      // AppAside,
      TheFooter,
      Breadcrumb,
      // DefaultAside,
      DefaultHeaderDropdownAccnt,
      SidebarForm,
      SidebarFooter,
      SidebarToggler,
      SidebarHeader,
      SidebarNav,
      SidebarMinimizer
    },
    data() {
      return {
        app_name: "",
        nav: nav.items,
        company: "",
        companyId: 0,
        post: "",
        username: "",
        base: false,
        baseUrl: "/outsource",
        accountant: false,
        accountantUrl: "/accounting-documents-list",
        inventory: false,
        inventoryUrl: "/documents",
        order: false,
        orderUrl: "/order",
        useradmin: false,
        useradminUrl: "/users",
        biAccess: false,
        biAccessUrl: "/comming-soon",
        works: false,
        worksUrl: "/works-home",
        planning: false,
        planningUrl: "/planning-orders",
        pm: false,
        pmUrl: "/devices",
        productionManagement: false,
      };
    },
    mounted() {
      this.app_name = Constants.APP_NAME;
      this.base = this.accountant = this.inventory = this.useradmin = this.productionManagement = this.biAccess = this.works = this.dashboard = this.order = this.pm = this.planning = false;
      let accesses = JSON.parse(localStorage.getItem("accesses"));
      let postId = localStorage.getItem("postId");
      if (accesses && accesses.map) {
        let names = accesses.map(a => {
          return a.page.persianName;
        });
        if (postId === "3006" || names.includes("مدیریت تولید")) {
          this.productionManagement = true;
        }
        if (
          postId === "3006" ||
          names.includes("واحدها") ||
          names.includes("شرکت ها") ||
          names.includes("شرکت های خارجی") ||
          names.includes("نوع حواله") ||
          names.includes("الگوها") ||
          names.includes("وضعیت سفارش")
        ) {
          this.base = true;
          this.baseUrl = names.includes("شرکت های خارجی")
            ? "/outsource"
            : names.includes("شرکت ها")
              ? "/company"
              : names.includes("شرکت های خارجی")
                ? "/outsource"
                : names.includes("الگوها")
                  ? "/product-patterns"
                  : names.includes("وضعیت سفارش")
                    ? "/store-order-status"
                    : "/home";
        }
        if (
          postId === "3006" ||
          names.includes("سرفصل حساب ها") ||
          names.includes("اسناد حسابداری") ||
          names.includes("بانک ها") ||
          names.includes("حساب های بانکی")
        ) {
          this.accountant = true;
          this.accountantUrl = names.includes("اسناد حسابداری")
            ? "/accounting-documents-list"
            : names.includes("سرفصل حساب ها")
              ? "/accounts-titles"
              : names.includes("بانک ها")
                ? "/banks"
                : names.includes("حساب های بانکی")
                  ? "/bank-accounts"
                  : "/home";
        }
        if (
          postId === "3006" ||
          names.includes("اسناد انبار") ||
          names.includes("سفارش فروش") ||
          names.includes("سفارش خرید") ||
          names.includes("کارتکس کالا") ||
          names.includes("محصولات") ||
          names.includes("نوع سند") ||
          names.includes("واحدها")
        ) {
          this.inventory = true;
          this.order = true;
          if (postId !== "3006") {
            this.inventoryUrl = names.includes("اسناد انبار")
              ? "/documents"
              : names.includes("سفارش فروش")
                ? "/order"
                : names.includes("سفارش خرید")
                  ? "/purchase-order"
                  : names.includes("کارتکس کالا")
                    ? "/kardex"
                    : names.includes("محصولات")
                      ? "/products"
                      : names.includes("واحدها")
                        ? "/units"
                        : names.includes("نوع سند")
                          ? "/voucher-type"
                          : "/home";
          }
        }
        if (
          postId === "3006" ||
          names.includes("کاربر ها") ||
          names.includes("سمت ها") ||
          names.includes("اشخاص")
        ) {
          this.useradmin = true;
          this.useradminUrl = names.includes("کاربر ها")
            ? "/users"
            : names.includes("سمت ها")
              ? "/access"
              : names.includes("اشخاص")
                ? "/persons"
                : "/home";
        }
        if (
          postId === "1" ||
          names.includes("اطلاعات پایه") ||
          names.includes("اطلاعات پرسنلی") ||
          names.includes("کارکرد/بدهی") ||
          names.includes("گزارشات") ||
          names.includes("محاسبات")
        ) {
          this.biAccess = true;
          this.biAccessUrl = names.includes("اطلاعات پایه")
            ? "/commingsoon"
            : names.includes("اطلاعات پرسنلی")
              ? "/commingsoon"
              : names.includes("کارکرد/بدهی")
                ? "/commingsoon"
                : names.includes("گزارشات")
                  ? "/commingsoon"
                  : names.includes("محاسبات")
                    ? "/commingsoon"
                    : "/comming-soon";
        }
        // task-flow subset
        /*if (postId === "1" || names.includes("الگو گذاری")) {
          this.patterns = true;
          this.patternsUrl = names.includes("الگو گذاری")
          if ("patterns") {
            this.patternsUrl = names.includes("الگو گذاری")
          } else {
            this.patternsUrl = names.includes("الگو گذاری")
          }
        }*/
        if (
          postId === "1" ||
          names.includes("کارها")
        ) {
          this.works = true;
          this.worksUrl = names.includes("کارها") ? "/works-home" : names.includes("کارها")
        }
        if (
          postId === "1" ||
          names.includes("کارها")
        ) {
          this.planning = true;
          this.planningUrl = names.includes("برنامه ریزی") ? "/planning-orders" : names.includes("برنامه ریزی")
        }
        if (
          postId === "1" ||
          names.includes("کارها")
        ) {
          this.pm = true;
          this.pmUrl = names.includes("برنامه ریزی") ? "/devices" : names.includes("برنامه ریزی")
        }
      }
      this.company = localStorage.getItem("company");
      this.companyId = localStorage.getItem("companyId");
      this.post = localStorage.getItem("post");
      this.username = localStorage.getItem("username");
    },
    methods: {
      _setNavItems(type) {
        setTimeout(() => {
          EventBus.$emit("changeNavItems", type);
        }, 50);
      }
    },
    computed: {
      name() {
        return this.$route.name;
      },
      list() {
        return this.$route.matched.filter(
          route => route.name || route.meta.label
        );
      }
    }
  };
</script>
